const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d`, `62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d`, 1, 67), undefined, false, false, 1));
            }

            getTemplateName() {
                return `62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d`;
            }

            getSourceContext() {
                return new this.Source(``, `62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d`, ``);
            }
        }],
        [67, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/input/select.twig`, `62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d`, 1);

                this.blocks = new Map([
                    ['options', [this, 'block_options']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/input/select.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_options(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <option value="this">This</option>
    <option value="that">That</option>
    <option value="other">Other</option>
    <option value="none">None</option>
  `);
            }

            getTemplateName() {
                return `62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d');

let template = env.loadTemplate('62f9766269c6a417026d7688e8803af6e29091bfd25c1b0686698a49faa0ea2d');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/input/demo/select.twig", args: context }
     );
     return rendered;;
};